import { render, staticRenderFns } from "./InformacionContribuyente.vue?vue&type=template&id=3ec4adc0&scoped=true"
import script from "./InformacionContribuyente.vue?vue&type=script&lang=js"
export * from "./InformacionContribuyente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec4adc0",
  null
  
)

export default component.exports